export default __webpack_public_path__ + "img/72e140a4400fe50f1ec1b9111156a6b3.png";